import axiosClient from '../index'
import ElectricMeter from './functions/ElectricMeter'

class DevicesApi {
    get(id) {
        return axiosClient.get(`/devices/${id}`)
    }

    addDevice(id, displayName){
        return axiosClient.post(`/devices/${id}`, {
            class: 'Meter',
            displayName,
            function: 'Basic'
        })
    }

    updateDisplayName(id, displayName){
        return axiosClient.put(`/devices/${id}`, {
            function: 'Basic',
            class: 'Meter',
            data: {
                assetId: id,
                displayName: displayName
            }
        })
    }

    functionData(id, functionName){
        return axiosClient.get(`/devices/${id}/functions/${functionName}`)
    }

    get ElectricMeter(){
        return new ElectricMeter(axiosClient)
    }
}

export default new DevicesApi()
